import React from "react";
import { useLanguage } from "../context/LanguageContext";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";

// Shared layout for legal / policy pages
const LegalPage = ({ data, path }) => {
  const { lang } = useLanguage();
  const c = data[lang];

  return (
    <>
      <Seo title={c.title} description={c.intro} path={path} lang={lang} />
      <PageHero title={c.title} desc={c.updated} />

      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <p className="text-slate-600 leading-relaxed mb-12" data-testid="legal-intro">
            {c.intro}
          </p>

          <div className="space-y-10">
            {c.sections.map((s, i) => (
              <div key={i} data-testid={`legal-section-${i}`}>
                <h2 className="font-display font-bold text-xl text-navy-900 mb-3">
                  {i + 1}. {s.heading}
                </h2>
                {s.body.map((p, j) => (
                  <p key={j} className="text-slate-600 leading-relaxed mb-3">
                    {p}
                  </p>
                ))}
                {s.list && (
                  <ul className="mt-2 space-y-2">
                    {s.list.map((li, k) => (
                      <li key={k} className="flex gap-3 text-slate-600 leading-relaxed">
                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-amber-500 shrink-0" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-500 leading-relaxed">{c.contactNote}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default LegalPage;
